(function ($) {
    const $fab = $("#contact-fab");
    const $modal = $("#contact-modal");
    const $backdrop = $("#contact-modal-backdrop");
    const $close = $("#contact-close");

    function openModal() {
        $modal.addClass("is-open");
        $backdrop.addClass("is-open");
        $fab.attr("aria-expanded", "true").addClass("is-active");
    }

    function closeModal() {
        $modal.removeClass("is-open");
        $backdrop.removeClass("is-open");
        $fab.attr("aria-expanded", "false").removeClass("is-active");
    }

    // Клик по кнопке: если уже активна → закрыть, иначе → открыть
    $fab.on("click", function () {
        if ($fab.hasClass("is-active")) {
            closeModal();
        } else {
            openModal();
        }
    });

    // Крестик
    $close.on("click", closeModal);

    // Клик по фону
    $backdrop.on("click", closeModal);

    // Esc
    $(document).on("keyup", function (e) {
        if (e.key === "Escape") {
            closeModal();
        }
    });

})(jQuery);


